import React from 'react';
import Link from 'components/Link/Link';
import s from './BoardListing.scss';
import ImageV2 from '../ImageV2';
import InterSectionBorder from '../InterSectionBorder/InterSectionBorder';

const BoardListing = props => {
  const { items, isWapView, isLandingPage } = props;

  return (
    <>
      <div className={s.allBoardPages}>
        <div className={s.boardCardWrapper}>
          {items &&
            Array.isArray(items) &&
            items.length > 0 &&
            items.map(board => (
              <Link
                to={board.overridelink}
                className={`${s.boardCard} ${s.boardCardListing} ${s.active}`}
              >
                <div className={`${s.boardLogo}`}>
                  <ImageV2
                    //resizemode="75"
                    width="50"
                    msid={
                      board &&
                      board?.metainfo &&
                      board?.metainfo?.CARDPAGEID &&
                      board?.metainfo?.CARDPAGEID?.value
                    }
                    alt={board?.title}
                  />
                </div>
                <div className={s.boardhead}>
                  <div className={s.heading}>{board.title}</div>
                  {board &&
                  board?.metainfo &&
                  board?.metainfo?.CARDPAGECODE &&
                  board?.metainfo?.CARDPAGECODE?.value ? (
                    <div className={s.result_Out}>
                      {board &&
                        board?.metainfo &&
                        board?.metainfo?.CARDPAGECODE &&
                        board?.metainfo?.CARDPAGECODE?.value}
                    </div>
                  ) : (
                    <div className={s.desc}>
                      {board &&
                        board?.metainfo &&
                        board?.metainfo?.CARDPAGETEMPLATE &&
                        board?.metainfo?.CARDPAGETEMPLATE?.value}
                    </div>
                  )}
                </div>
              </Link>
            ))}
        </div>
      </div>
      {!isWapView && isLandingPage && <InterSectionBorder />}
    </>
  );
};

export default BoardListing;
